// Side effect imports
import './prototype';

import { createDuration } from './create';
import { isDuration } from './constructor';
import {
    getSetRelativeTimeRounding,
    getSetRelativeTimeThreshold
} from './humanize';

export {
    createDuration,
    isDuration,
    getSetRelativeTimeRounding,
    getSetRelativeTimeThreshold
};
